<template>
  <div class="container mx-auto p-4" v-if="isLoaded">
    <div class="bg-white rounded-lg p-4 contenedor-modal-evento w-full">
      <form @submit.prevent="submitForm" >
        <div id="espacio_campos">
          <div class="switch-container mb-4 flex items-center">
            <span class="mr-2 text-sm font-medium text-gray-700 cursor-pointer" @click="toggleSwitch">Permitir usuarios duplicados</span>
            <div class="relative cursor-pointer" @click="toggleSwitch">
              <div :class="switchBgClass" class="switch-bg"></div>
              <div :class="switchDotClass" class="switch-dot"></div>
            </div>
          </div>
          <!-- <div class="label-expand-campos flex justify-between items-center mb-2 cursor-pointer" @click="toggleCampos">
            <span>Configurar Campos</span>
            <span class="material-icons">
              {{ camposVisible ? 'expand_less' : 'expand_more' }}
            </span>
          </div> -->
          <!-- Switch para Copia al Emisor -->


          <transition name="fade">
            <div v-if="camposVisible" id="tabla_campos" class="grid grid-cols-2 gap-4">
              <div v-for="campo in camposRegistro" :key="campo.id_campo" class="campo-registro flex justify-between items-center">
                <div class="flex-grow">
                  <input type="checkbox" :id="campo.name_campo" v-model="campo.activo" class="hidden" />
                  <label :for="campo.name_campo" :class="{'activo': campo.activo, 'cursor-pointer': true}">
                    {{ campo.nombre_del_campo }}
                  </label>
                </div>
                <div class="checkboxes">                
                  <input type="checkbox" :id="'required-' + campo.name_campo" v-model="campo.requerido" :disabled="campo.mandatorio" class="form-checkbox checkbox-required" data-label="O"/>
                  <input type="checkbox" :id="'mandatorio-' + campo.name_campo" v-model="campo.mandatorio"  v-show="!evento.permitir_duplicados"  class="form-checkbox checkbox-mandatorio" data-label="M" @change="checkRequerido(campo)" />

                </div>
              </div>
            </div>
          </transition>
          <div class="rol">
              <input type="radio" id="asistente" name="tipoAsistente" value="asistente" checked v-model="evento.tipo_asistente">
              <label for="asistente" class="btn-radio">Asistente</label>
  
              <input type="radio" id="asistentevirtual" name="tipoAsistente" value="asistentevirtual" v-model="evento.tipo_asistente">
              <label for="asistentevirtual" class="btn-radio">Asistente Virtual</label>
            </div>
        </div>
        <hr>
        <div class="formulario">
          <div class="mb-6">
            <label for="nombre" class="block mb-2 text-sm font-medium text-gray-700">Nombre del evento</label>
            <input type="text" id="nombre" v-model="evento.nombre" class="mt-1 w-full border-gray-300 rounded-md shadow-sm" required>
          </div>
          <div class="mb-6">
            <label for="fecha_inicio" class="block mb-2 text-sm font-medium text-gray-700">Fecha de corte</label>
            <input type="datetime-local" id="fecha_inicio" v-model="evento.fecha_inicio" class="mt-1 w-full border-gray-300 rounded-md shadow-sm" required>
          </div>
          <div class="mb-6">
            <label for="fecha_fin" class="block mb-2 text-sm font-medium text-gray-700">Fecha de fin</label>
            <input type="datetime-local" id="fecha_fin" v-model="evento.fecha_fin" class="mt-1 w-full border-gray-300 rounded-md shadow-sm" required>
          </div>
          <div class="mb-6">
            <label for="codigo" class="block mb-2 text-sm font-medium text-gray-700">Código (opcional)</label>
            <input type="text" id="codigo" v-model="evento.codigo" class="mt-1 w-full border-gray-300 rounded-md shadow-sm">
          </div>
              <!-- URL del Evento -->
            <div class="mb-4">
              <label for="url_evento" class="block text-sm font-medium text-gray-700">URL del evento</label>              

              <div class="url">
                <input type="text" class="disabled input-style url-input" disabled="disabled" value="https://">
                <input type="text" id="url_evento" v-model="evento.api.url_evento" class="input-style" placeholder="Agrega solo dominio sin https" @blur="sanitizeURL">
                <input type="text" class="disabled input-style url-context" disabled="disabled" value="/wp-j..">
                
              </div>
            </div>
            <div class="col-12">

              <!-- Usuario -->
              <div class="mb-4">
                <label for="usuario" class="block text-sm font-medium text-gray-700">Usuario</label>
                <input type="text" id="usuario" v-model="evento.api.usuario" class="input-style" >
              </div>
              
              <!-- acceso -->
              <div class="mb-4">
                <label for="acceso" class="block text-sm font-medium text-gray-700">acceso</label>
                <input type="text" id="acceso" v-model="evento.api.acceso" class="input-style" >
              </div>
            </div>
            <div class="col-12">

              <div class="mb-4">
                <label for="contacto_nombre" class="block text-sm font-medium text-gray-700">Nombre de contacto</label>
                <input type="text" id="contacto_nombre" v-model="evento.api.contacto_nombre" class="input-style" >
              </div>
              
              <!-- acceso -->
              <div class="mb-4">
                <label for="contacto_telefono" class="block text-sm font-medium text-gray-700">Telefono de contacto</label>
                <input type="text" id="contacto_telefono" v-model="evento.api.contacto_telefono" class="input-style" >
              </div>
            </div>
              <div class="mb-4">
              <label for="contacto_email" class="block text-sm font-medium text-gray-700">Correo de contacto</label>
              <input type="text" id="contacto_email" v-model="evento.api.contacto_email" class="input-style" >
            </div>
          <button type="submit" class="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
    <div class="col-12 mt-5 mensaje-personalizado">
      <h2 >Personaliza el mensaje para los invitados </h2>
      <div class="switch-container mb-4 flex items-center">
        <span class="mr-2 text-sm font-medium text-gray-700 cursor-pointer">¿Enviar copia de invitación al emisor?</span>
        <div class="relative cursor-pointer" @click="toggleCopiaEmisor">
          <div :class="switchBgClassCopia" class="switch-bg"></div>
          <div :class="switchDotClassCopia" class="switch-dot"></div>
        </div>
      </div>

      <RichTextEditor :nombreEvento="evento.nombre" :tokenEvento="$route.params.token" />


    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import RichTextEditor from '@/components/RichTextEditor.vue'

export default {
  data() {
    return {
      evento: {
        nombre: '',
        fecha_inicio: '',
        fecha_fin: '',
        codigo: '',
        permitir_duplicados: false,
        tipo_asistente: 'asistente',
        api: {
          url_evento: '',
          usuario: '',
          acceso: ''
        }
      },
      camposRegistro: [], // Almacenará los campos de registro activos
      isLoaded: false,
      camposVisible: false // Controla la visibilidad de la sección de campos
    };
  },
  components: {
    RichTextEditor
  },
  computed: {
    switchBgClass() {
      return this.evento.permitir_duplicados ? 'bg-green-500' : 'bg-gray-600';
    },
    switchDotClass() {
      return this.evento.permitir_duplicados ? 'translate-x-9' : 'translate-x-1';
    },
    switchBgClassCopia() {
    return this.evento.copia_invitacion_emisor ? 'bg-green-500' : 'bg-gray-600';
    },
    switchDotClassCopia() {
      return this.evento.copia_invitacion_emisor ? 'translate-x-9' : 'translate-x-1';
    }
  },
 
  methods: {
    sanitizeURL() {
      let url = this.evento.api.url_evento;
      // Eliminar espacios en blanco
      url = url.replace(/\s+/g, '');
      // Eliminar protocolo
      url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');
      // Eliminar todo después del primer slash
      url = url.replace(/\/.*$/, '');
      // Actualizar el valor visible y el valor que se enviará
      this.evento.api.url_evento = url;
    },

    checkRequerido(campo) {
      if (campo.mandatorio) {
        campo.requerido = true;
      }
    },
    toggleSwitch() {
      this.evento.permitir_duplicados = !this.evento.permitir_duplicados;
      if (!this.evento.permitir_duplicados && !this.camposVisible) {
        this.camposVisible = true;
      }
    },
    toggleCampos() {
      if (!this.evento.permitir_duplicados) {
        this.camposVisible = true; // Siempre visible cuando no permitimos duplicados
      } else {
        this.camposVisible = !this.camposVisible;
      }
    },
    async submitForm() {
      this.sanitizeURL();
      const camposInfo = this.camposRegistro.map(campo => ({
        label: campo.name_campo,
        activo: campo.activo,
        requerido: campo.requerido || false, 
        mandatorio: campo.mandatorio || false
      }));
      const payload = {
        ...this.evento,
        permitir_duplicados: this.evento.permitir_duplicados ? 1 : 0,
        campos: camposInfo
      };
      try {
        const response = await fetch(`/api/eventos/update/${this.evento.token}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        this.toast.success('Evento actualizado: ' + data.status);
        this.$router.push('/eventos');
      } catch (error) {
        this.toast.error('Error al actualizar el evento');
      }
    },
    async fetchCamposRegistro() {
      try {
        const response = await fetch('/api/campos-registro');
        const data = await response.json();
        this.camposRegistro = data.data.map(campo => ({
          ...campo,
          activo: campo.activo === '1', // Asumiendo que la API devuelve '1' o '0' como string
          mandatorio: false  // Inicializar mandatorio a false por defecto
        }));
      } catch (error) {
        this.toast.error('Error al cargar los campos del registro: ' + error.message);
      }
    },

    async fetchEvento() {
      try {
        const response = await fetch(`/api/eventos/${this.$route.params.token}`);
        const data = await response.json();
        this.evento = {
          ...data,
          permitir_duplicados: data.permitir_duplicados === "1",
          copia_invitacion_emisor: data.copia_invitacion_emisor === "1",
          fecha_inicio: data.fecha_inicio.slice(0, 16),
          fecha_fin: data.fecha_fin.slice(0, 16),
          api: data.api
        };

        // Si existe configuración específica de campos, la procesamos
        if (data.campos_obligatorios && data.campos_obligatorios !== "null") {
          const camposEspecificos = JSON.parse(data.campos_obligatorios);

          // Actualizamos los camposRegistro basados en los campos específicos recibidos
          this.camposRegistro = this.camposRegistro.map(campo => {
            const campoEspecifico = camposEspecificos.find(c => c.label === campo.name_campo);
            return campoEspecifico ? {
              ...campo,
              activo: campoEspecifico.activo,
              requerido: campoEspecifico.requerido,
              mandatorio: campoEspecifico.mandatorio
            } : campo;
          });
        }
        this.isLoaded = true;
      } catch (error) {
        this.toast.error('Error al cargar el evento: ' + error.message);
      }
      
    },
    async toggleCopiaEmisor() {
      this.evento.copia_invitacion_emisor = !this.evento.copia_invitacion_emisor;

      try {
        const response = await fetch(`/api/eventos/copia-invitacion/${this.evento.token}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ copia: this.evento.copia_invitacion_emisor ? '1' : '0' })

        });
        const result = await response.json();
        if (result.status === 'ok') {
          this.toast.success('Se actualizó la preferencia de copia al emisor.');
        } else {
          this.toast.error('No se pudo actualizar la preferencia.');
        }
      } catch (error) {
        this.toast.error('Error en la solicitud.');
      }
    }

  },
  async created() {
    this.toast = useToast();
    await this.fetchCamposRegistro(); // Espera a que esta promesa se resuelva antes de proceder
    await this.fetchEvento(); // Ahora carga el evento
    
    // Ajustar la visibilidad basada en el estado inicial de `permitir_duplicados`
    if (!this.evento.permitir_duplicados) {
      this.camposVisible = true;
    }
  }

};
</script>

<style lang="scss" scoped>

.contenedor-modal-evento{

  max-width: 1000px
}
.switch-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;

}
.rol {

  display: flex;
  justify-content: space-between;
  
} 


.switch-bg {
  width: 4rem;
  height: 2rem;
  border-radius: 9999px;
  transition: background-color 0.2s;
}

.switch-dot {
  width: 1.5rem;
  height: 1.5rem;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 0.25rem;
  transition: transform 0.2s;
}


.input-style {


  display: block;
  width: 100%;
  padding: 0.625rem;
  border: 1px solid #cccccc;
  border-radius: 0.375rem;
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
  &:focus {

    outline: none;
    border-color: #3182ce;
    ring: #3182ce;
  }
}
.btn-blue {


  background-color: #2563eb;
  &:hover{
    
    background-color: #1d4ed8;
  }
  }
.btn-red {
  background-color: #ef4444;
  &:hover{
    background-color: #dc2626;
  }
}


#tabla_campos {
  padding-bottom: 30px;
}
.campo-registro label {
  
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background: gray;
  color: white;
  border-radius: 5px;
  transition: background-color 0.3s;

  cursor: pointer; // Esto cambia el cursor a un puntero, indicando que el elemento es interactivo
  &::selection {
    background: transparent;
  }
  &:hover {
    background: darken(gray, 10%); // Oscurece el fondo cuando se pasa el mouse por encima
  }
}
// .form-checkbox {
//   // margin-left: 10px; // Espacio entre el label y el checkbox
//   transform: scale(2);
//   margin-left: 15px;
// }

hr {
  margin-bottom: 15px;
}


.campo-registro label.activo {
  background: green;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.checkbox-required,
.checkbox-mandatorio {
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;
  transform: scale(1.5);
  // margin-left: 5px;
  margin-left: 15px;
  -webkit-appearance: none; // Remover el estilo por defecto
  background-color: #eee; // Color de fondo por defecto
  border-radius: 4px;
  vertical-align: middle;
  &:before {
    content: attr(data-label);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: black;
  }
  &:checked {
    &:before { 
      font-weight: bold;
      color: #fff;
    }
    background-color: green; // Cambiar fondo a verde si es obligatorio y está activo
  }
}

.checkbox-mandatorio:checked {
  background-color: orange; // Cambiar fondo a naranja si es mandatorio y está activo
  &:before { 
     
      color: #000;
    }
}
hr {
  margin-bottom: 15px;

}


#tabla_campos  
{
  padding-bottom: 30px;

}

.checkbox-mandatorio:checked  
{
  background-color: orange; // Cambiar fondo a naranja si es mandatorio y está activo
  &:before{
    color: #000;

  }  

}
    
.z-index-2 
{
  z-index: 2;
}

.rol  
{

  display: flex;
  justify-content: space-between;
}


.btn-radio  
{

  display: block;
  width: 49%;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border: none;
  color: white;
  background-color: gray;
  transition: background-color 0.3s ease;
  border-radius: 5px;
}


input[type="radio"]  
{

  display: none;
}


input[type="radio"]:checked + label  
{
  background-color: #008000;

}


input[type="radio"]:not(:checked) + label  
{
  background-color: #808080;

}
.contenedor-modal-evento{

  max-width: 1000px;
}

form 
{


  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .switch-container
  {
    width: 100%;

  }
  #espacio_campos,.formulario {
    width: 100%;
    max-width: 48%;

  }
  #espacio_campos
  {

    align-items: center;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    .rol {
      width: 100%;

    }
  }
}
.url {
  display: flex;
  .url-input {

    max-width: 60px;
    padding-left: 2px;
    padding-right: 2px;
  }
  .url-context{

    max-width: 60px;
    padding-left: 4px;
    padding-right: 2px;
  }
}
.col-12 {
  display: flex;
  justify-content: space-between;
}
.mensaje-personalizado {
  display: flex;
  flex-direction: column;
  background: rgba(255,255,255,0.5);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;

  h2 {
    font-weight: bold;
    font-size: 1.5em;
    margin: 20px auto;
    text-align: center;
  }
  .switch-container{
    justify-content: center;

  }

}
</style>

